"use strict";

const rtbs = new Swiper( '.rtbs .swiper', {
	breakpoints: {
		1024: {
			slidesPerView: 3,
			spaceBetween: 20
		},
    1280:{
      slidesPerView: 4,
      spaceBetween: 20
    }
	},
	pagination: {
		el: '.swiper-pagination'
	},
	slidesPerView: 1.05,
	spaceBetween: 10, 
} );

const testimonials = new Swiper( '.testimonials .swiper', {
	breakpoints: {
		1024: {
			slidesPerView: 3,
      pagination: false,
		}
	},
	navigation: {
		nextEl: '.testimonials__inner .swiper-button-next',
		prevEl: '.testimonials__inner .swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination'
	},
	slidesPerView: 1.05,
	spaceBetween: 20,
  initialSlide: 1,
} );

addEventListener( "resize", ( event ) => {
	rtbs.update();
	testimonials.update();
} );



